import { getFlagStyles } from './FlagStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { FlagSize } from './types/size.js';

const CDN_FLAGS_PATH = 'apps/flags';
const Flag = _ref => {
  let {
    country,
    cdnUrl,
    size = FlagSize.REGULAR,
    ...rest
  } = _ref;
  return jsx("img", {
    ...rest,
    css: getFlagStyles(size),
    "aria-hidden": "true",
    alt: country,
    "data-id": `FLAG-${country}`,
    src: `${cdnUrl}/${CDN_FLAGS_PATH}/${country.toUpperCase()}.svg`
  });
};

export { Flag };
//# sourceMappingURL=Flag.js.map
